/*
================================================================================
| FILENAME: src/components/Modal.jsx (Corrected)
| PURPOSE: To fix the React error by changing to a default export.
|
| KEY FIXES:
| 1.  Changed `const Modal = ...; export default Modal;` to a more direct
|     `export default function Modal(...)`. This resolves the import mismatch.
================================================================================
*/
import React from 'react';
import { X } from 'lucide-react';

// The original was: const Modal = ...; export default Modal;
export default function Modal({ isOpen, onClose, title, children }) {
    if (!isOpen) return null;

    return (
        <div 
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center"
            onClick={onClose}
        >
            <div 
                className="bg-slate-800 rounded-lg shadow-xl w-full max-w-md m-4 border border-slate-700"
                onClick={(e) => e.stopPropagation()}
            >
                <header className="flex items-center justify-between p-4 border-b border-slate-700">
                    <h2 className="text-xl font-bold text-white">{title}</h2>
                    <button 
                        onClick={onClose} 
                        className="p-1 rounded-full text-slate-400 hover:bg-slate-700 hover:text-white"
                    >
                        <X size={20} />
                    </button>
                </header>
                <div className="p-6">
                    {children}
                </div>
            </div>
        </div>
    );
};